import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ClientSwitcherDropdownComponent } from '../../components/client-switcher-dropdown/client-switcher-dropdown.component';
import { SharedModule } from '../../shared.module';
import { AppHeaderComponent } from './app-header.component';

@NgModule({
  declarations: [AppHeaderComponent, ClientSwitcherDropdownComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    SharedModule
  ],
  exports: [AppHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppHeaderModule {}
